export const clientsData = [
  {
    id: 1,
    imageSrc: "./img/clients1.png",
    name: "M/s. ITC Ghaziabad",
  },
  {
    id: 2,
    imageSrc: "./img/clients2.png",
    name: "M/s. Indian Oil Corporation",
  },
  {
    id: 3,
    imageSrc: "./img/clients3.png",
    name: "M/s. Bharat Petroleum Corporation Ltd",
  },
  {
    id: 4,
    imageSrc: "./img/clients4.png",
    name: "M/s. Hindustan Petroleum Corporation",
  },
  {
    id: 5,
    imageSrc: "./img/client5.png",
    name: "M/s. Ralson India Ltd",
  },
  {
    id: 6,
    imageSrc: "./img/client6.png",
    name: "M/s. JCT Ltd. (Jalandhar)",
  },
  {
    id: 7,
    imageSrc: "./img/client7.png",
    name: "M/s. BKT Cold Storage, Lucknow",
  },
  {
    id: 8,
    imageSrc: "./img/clients1.png",
    name: "M/s. Bajaj Hindusthan Sugars Ltd",
  },
  {
    id: 9,
    imageSrc: "./img/clients2.png",
    name: "M/s. DCM Shriram Industries Ltd",
  },
  {
    id: 10,
    imageSrc: "./img/clients3.png",
    name: "M/s. Parle Sugar Ltd (Bahraich)",
  },
  {
    id: 11,
    imageSrc: "./img/clients4.png",
    name: "M/s. Simbhaoli Sugar Ltd",
  },
  {
    id: 12,
    imageSrc: "./img/client5.png",
    name: "M/s. Dalmia Bharat Sugar Ltd",
  },
  {
    id: 13,
    imageSrc: "./img/client6.png",
    name: "M/s. Magadh Sugar & Energy Ltd",
  },
  {
    id: 14,
    imageSrc: "./img/client7.png",
    name: "M/s. RockMan Industries",
  },
  {
    id: 15,
    imageSrc: "./img/clients1.png",
    name: "M/s. Eveready Industries, Noida",
  },
  {
    id: 16,
    imageSrc: "./img/clients2.png",
    name: "M/s. Bikanerwala Foods Pvt Ltd",
  },
  {
    id: 17,
    imageSrc: "./img/clients3.png",
    name: "M/s. Audi Lucknow & Punjab",
  },
];

export const galleryData = [
  {
    id: 1,
    imageSrc: "./img/gallery/Banner_11.jpg",
    name: "Industrial Testing Operations"
  },
  {
    id: 2,
    imageSrc: "./img/gallery/2.jpg",
    name: "Statutory Machine Auditing"
  },
  {
    id: 3,
    imageSrc: "./img/gallery/5847.png",
    name: "Plant Inspections & Verifications"
  },
  {
    id: 4,
    imageSrc: "./img/gallery/cranes_inspection.jpg",
    name: "Lifting Machinery Load Testing"
  },
  {
    id: 5,
    imageSrc: "./img/gallery/pressure_vessel.jpg",
    name: "Pressure Vessel Hydrostatic Examination"
  },
  {
    id: 6,
    imageSrc: "./img/gallery/safety_audit.jpg",
    name: "Process Safety Audit & Hazard Review"
  },
  {
    id: 7,
    imageSrc: "./img/gallery/factory_inspection.jpg",
    name: "Mechanical & Structural Quality Assessment"
  },
];

export const ourService = [
  {
    id: 1,
    image: "./img/railway-consultancy.jpg",
    title: "Lifts And Hoists",
    description:
      "Testing And Certification Of Lifts And Hoists Under Section 28 As Per Factories Act 1948.",
  },
  {
    id: 2,
    image: "./img/drone-survey.jpg",
    title: "Lifting Machinery",
    description:
      "Testing And Certification Of Cranes, Tackles, Chaines, Ropes Under section 29 As Per Factories Act 1948.",
  },
  {
    id: 3,
    image: "./img/Energy.jpg",
    title: "Pressure Plants/Vessels",
    description:
      "Testing And Certification Of Pressure Plants/Vessels Under section 31 As Per Factories Act 1948.",
  },
  {
    id: 4,
    image: "./img/echosounderr.jpg",
    title: "Safety Audits",
    description:
      "HMT Technical Services Conduct Safety Audits Of The Process.",
  },
];

export const prductData = [
  {
    id: 1,
    image: "./img/product1.webp",
    title: "Measuring Instruments",
    description:
      "Manufacturer of a wide range of products which include e1 class weight box, decade inductance box, f1 class weight box, mitutoyo vernier caliper ., ultrasonic thickness gauges . and slip gauge accessories set.",
    subpoints:
      "1. We are one of the major names in the industry engaged in offering E1 Class Weights to the clients. The offered E2 class weights are commonly used in the calibration of weights related to lower accuracy class and for use with weighing instruments related to class I. 3.No. of Weights : 23 .4.Content : 1mg to 200g ( SS )",
  },
  {
    id: 2,
    image: "./img/prodcut2.webp",
    title: "Baumer Pressure Gauge",
    description: "Introducing our high-precision Digital Pressure Gauge, engineered to deliver unparalleled accuracy and reliability across a wide spectrum of pressure ranges. With an impressive accuracy of ± 0.05% of Full Scale (F.S.), this gauge ensures precise measurements, making it an ideal choice for demanding industrial applications where precision is paramount. ",
    subpoints:
      "1.Exceptional Accuracy: Enjoy peace of mind with precise pressure readings, thanks to the ± 0.05% F.S. accuracy of our digital gauge.  2.Versatile Range: Whether you require measurements in psi, bar, kg/cm², or any other unit, our gauge offers flexibility with its availability in all ranges. 3.Robust Construction: Built to withstand harsh industrial environments, our digital pressure gauge features a rugged construction for long-lasting durability.  4.Easy-to-Read Display: The clear digital display provides easy readability, ensuring quick and accurate pressure readings at a glance.",
  },
  {
    id: 3,
    image: "./img/prodct3.webp",
    title: "Hand Pumps",
    description:
      "Our product range includes a wide range of pneumatic calibration hand pump. Introducing our cutting-edge Pneumatic Pump, designed to deliver efficient and reliable fluid transfer capabilities in various industrial applications. ",
    subpoints:
      "1.Powerful Pneumatic Operation: Harnessing the power of compressed air, our pneumatic pump provides robust fluid transfer performance, suitable for a wide range of liquids, including oils, fuels, and hydraulic fluids.  2.Versatile Compatibility: With its adaptable design, our pump is compatible with different fluid viscosities and chemical compositions, offering versatility and flexibility in fluid handling tasks. 3.Compact and Portable: The compact and lightweight construction of our pneumatic pump enables easy maneuverability and nstallation, making it ideal for both stationary and mobile applications.Durable Construction: Built to withstand demanding operating conditions, our pump features a rugged construction and corrosion-resistant materials, ensuring long-term reliability and durability.",
  },
  {
    id: 4,
    image: "./img/product4.webp",
    title: "MEATEST M151 High Current Calibrator",
    description:
      "M151 Current Calibrator can generate up to 120 A with one year accuracy ranging from 0.035% to 0.11% at all points.",
    subpoints:
      "1.Key signal parameters including selected function, uncertainty and AC signal frequency are shown on large LCD, softkeys under the display are linked to frequently used functions for quick setup.",
  },
];
